/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

/**
 * Do nothing within intention
 * @param {...any} args any number of arguments can be supplied, all will be ignored
 */
export const noop = (...args: any[]) => {};
